import { Route, Routes, Navigate } from "react-router-dom";
import Submissions from "../Pages/Submissions";
import AdminHome from "../Admin/AdminHome";
import AdminLayout from "../Admin/Layout";
import Accounts from "../Pages/Accounts";
import AdminExecutives from "../Pages/AdminExecutives";
import AdminGallery from "../Pages/AdminGallery";
import AdminResources from "../Pages/AdminResources";

function AdminRoute() {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true"; // Check authentication
  const userRole = localStorage.getItem("userRole"); // Get user role

  // If not authenticated, redirect to login page
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <AdminLayout>
        <Routes>
          <Route path="/" element={<AdminHome />} />
          <Route path="/submissions" element={<Submissions />} />
          <Route path="/executives" element={<AdminExecutives />} />
          <Route path="/gallery" element={<AdminGallery />} />
          <Route path="/resources" element={<AdminResources />} />

          {/* Restrict /accounts to only TG and Auditor */}
          {userRole === "accounts" ? (
            <Route path="/accounts" element={<Accounts />} />
          ) : (
            <Route path="/accounts" element={<Navigate to="/login" />} />
          )}
        </Routes>
      </AdminLayout>
    </>
  );
}

export default AdminRoute;
